export const enum AccessLevel {
    Public = "Public",
    Private = "Restricted through login",
    AccessCode = "Restricted through access code",
}
